import { CssRender as p } from "./ghl-ui.es385.js";
import { plugin as i } from "./ghl-ui.es386.js";
const a = "n", e = `.${a}-`, u = "__", d = "--", t = p(), c = i({
  blockPrefix: e,
  elementPrefix: u,
  modifierPrefix: d
});
t.use(c);
const {
  c: r,
  find: $
} = t, {
  cB: l,
  cE: M,
  cM: g,
  cNotM: x
} = c;
function C(o) {
  return r(({
    props: {
      bPrefix: n
    }
  }) => `${n || e}modal, ${n || e}drawer`, [o]);
}
function P(o) {
  return r(({
    props: {
      bPrefix: n
    }
  }) => `${n || e}popover`, [o]);
}
function v(o) {
  return r(({
    props: {
      bPrefix: n
    }
  }) => `&${n || e}modal`, o);
}
const B = (...o) => r(">", [l(...o)]);
function _(o, n) {
  return o + (n === "default" ? "" : n.replace(/^[a-z]/, (s) => s.toUpperCase()));
}
export {
  v as asModal,
  r as c,
  l as cB,
  B as cCB,
  M as cE,
  g as cM,
  x as cNotM,
  _ as createKey,
  $ as find,
  C as insideModal,
  P as insidePopover,
  a as namespace,
  e as prefix
};
